var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F67570",
    d: "M10.75 7.25C11.165625 7.25 11.5 7.5843749 11.5 8C11.5 8.4156246 11.165625 8.75 10.75 8.75L5.25 8.75C4.8343749 8.75 4.5 8.4156246 4.5 8C4.5 7.5843749 4.8343749 7.25 5.25 7.25L10.75 7.25ZM16 8C16 12.41875 12.41875 16 8 16C3.5812502 16 0 12.41875 0 8C0 3.5812502 3.5812502 0 8 0C12.41875 0 16 3.5812502 16 8ZM8 1.5C4.4093752 1.5 1.5 4.4093752 1.5 8C1.5 11.590625 4.4093752 14.5 8 14.5C11.590625 14.5 14.5 11.590625 14.5 8C14.5 4.4093752 11.590625 1.5 8 1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.7e07b2c392f9614e3a334671db65617d.svg";
export { ForwardRef as ReactComponent };